import React from "react";

const IntigrationUrl = ({ height = 24, width = 24, color = "#000" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1750_84)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.02634 7.55581H5.20391C4.72676 8.35674 4.4115 9.26418 4.30074 10.2334H8.02634V12.2293L12.9256 8.89567L8.02634 5.56201V7.55581Z"
            fill={color}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7275 2.1983C13.9204 2.43048 15.0302 2.89911 16.0015 3.55519L17.0624 2.49438C17.335 2.22173 17.7781 2.22173 18.0507 2.49438L19.5077 3.94926C19.7783 4.22192 19.7783 4.66499 19.5077 4.93765L18.4448 5.99845C19.1009 6.97192 19.5695 8.07959 19.8038 9.27246H21.3034C21.6869 9.27246 22 9.58559 22 9.97115V12.031C22 12.4144 21.6869 12.7275 21.3034 12.7275H19.8038C19.5695 13.9204 19.1009 15.0302 18.4469 16.0015L19.5077 17.0624C19.7783 17.335 19.7783 17.7781 19.5077 18.0507L18.0507 19.5077C17.7781 19.7783 17.335 19.7783 17.0624 19.5077L16.0015 18.4448C15.0281 19.1009 13.9204 19.5695 12.7275 19.8038V21.3034C12.7275 21.6869 12.4144 22 12.031 22H9.97115C9.58559 22 9.27246 21.6869 9.27246 21.3034V19.8038C8.07959 19.5695 6.97192 19.1009 5.99845 18.4469L4.93765 19.5077C4.66499 19.7783 4.22192 19.7783 3.94926 19.5077L2.49438 18.0507C2.22173 17.7781 2.22173 17.335 2.49438 17.0624L3.55519 16.0015C2.89911 15.0281 2.43048 13.9204 2.1983 12.7275H0.698683C0.313129 12.7275 0 12.4144 0 12.031V9.97115C0 9.58559 0.313129 9.27246 0.698683 9.27246H2.19617C2.43048 8.07959 2.89911 6.97192 3.55519 5.99845L2.49438 4.93765C2.22173 4.66499 2.22173 4.22192 2.49438 3.94926L3.94926 2.49438C4.22192 2.22173 4.66499 2.22173 4.93765 2.49438L5.99845 3.55519C6.97192 2.89911 8.07959 2.43048 9.27246 2.1983V0.698683C9.27246 0.313129 9.58559 0 9.97115 0H12.031C12.4144 0 12.7275 0.313129 12.7275 0.698683V2.1983ZM11 3.8598C14.9429 3.8598 18.1402 7.05713 18.1402 11C18.1402 14.9429 14.9429 18.1402 11 18.1402C7.05713 18.1402 3.8598 14.9429 3.8598 11C3.8598 7.05713 7.05713 3.8598 11 3.8598Z"
            fill={color}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.0653 11.8605H17.6886C17.5651 12.834 17.2328 13.7414 16.7407 14.5381H14.0653V16.5319L9.16595 13.1982L14.0653 9.8667V11.8605Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_1750_84">
            <rect width="22" height="22" fill={color} />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default IntigrationUrl;
